<template>
  <div>
    <div class="field field_search">
      <div class="field_left">
        <div class="field field_search multiselect" :class="{disabled: disabled, extended: showExtended}" tabindex="0">
          <label :for="name + '_id'">
            <slot/>
          </label>
          <input
              :id="name + '_id'"
              class="search clearable"
              :name="name"
              autocomplete="off"
              size="30"
              v-model="inputText"
              type="text"
              @focus="initSearch()"
              @input="onSearch"
              @blur.stop.prevent="onFocusOut"
              :disabled="disabled"
          />
          <a :style="clrBtnStyle" class="clearable_btn" :title="$gettext('Vymazat text')" @click="initSearch()" v-if="!disabled"><translate>Vymazat</translate></a>
          <div class="extended_search" :class="{extended: showExtended}">
            <ul v-if="filteredSelectableItems.length">
              <li v-for="item in filteredSelectableItems" :key="item.id">
                <a @mousedown.prevent="selectItem(item.id, item)">
                  <span class="item_id" v-if="showId" v-html="highlightSearchedText(item.id)"></span>
                  <span class="item_label" v-html="highlightSearchedText(item.text)"></span>
                </a>
              </li>
            </ul>
            <ul v-else>
              <li><translate>Zadejte vyhledávací řetězec</translate></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <table class="vypis vypis_detail" v-if="selectedIds.length > 0">
      <thead>
        <tr>
          <th class="no_padding drag_drop"></th>
          <th v-if="showId"><span class="name" v-translate>ID</span></th>
          <th><span class="name" v-translate>Název</span></th>
          <th v-if="!disabled"></th>
        </tr>
      </thead>
      <tbody :class="['sortable_' + name, {sortable: !disabled, 'ui-sortable': !disabled}]">
        <tr :class="['sorted_' + name, {'ui-sortable-handle': !disabled}]" v-for="id in selectedIds" :key="'row_' + name + '_' + id" :rowvalue="id">
          <td class="no_padding drag_drop"><span/></td>
          <td class="item_id" v-if="showId">{{ id }}</td>
          <td :data-th="$gettext('Název')" class="first_data">{{ getText(id) }}</td>
          <td class="no_padding edit" v-if="!disabled">
            <div class="edit_inner">
              <a class="btn btn_action btn_delete" :title="$gettext('Smazat')" @click.stop="removeItem(id)" v-translate>Smazat</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { highlightText } from '../../utils/helpers';

export default {
  name: "SortableSearchSelect",
  props: {
    value: Array,
    searchFunction: Function,
    defaultData: Object,
    disabled: Boolean,
    showId: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: "sortableSearch",
    },
  },
  data() {
    return {
      inputText: '',
      showExtended: false,
      selectableItems: [],
      selectedData: {},
      selectedIds: [],
      searchItemLimit: 15,
      keyPressTimeoutMiliseconds: 500,
      keyTimer: null,
      sortingEnabled: false,
    };
  },
  created() {
    this.selectedIds = this._dedupe(this.value || []);
    this.selectedData = this.defaultData ? { ...this.defaultData } : {};
  },
  mounted() {
    this.$nextTick(this._initSorting);
  },
  updated() {
    const exists = $('.sortable_' + this.name).length > 0;
    if (exists && !this.sortingEnabled) {
      this._initSorting();
    } else if (!exists && this.sortingEnabled) {
      this.sortingEnabled = false;
    }
  },
  computed: {
    filteredSelectableItems() {
      if (this.selectableItems) {
        return this.selectableItems
            .filter(item => !this._isSelected(item.id))
            .slice(0, this.searchItemLimit);
      }
      return [];
    },
    clrBtnStyle() {
      return this.inputText === '' ? 'display: none' : 'display: inline';
    },
  },
  methods: {
    getText(id) {
      return this.selectedData.hasOwnProperty(id) ? this.selectedData[id].text : '';
    },
    _dedupe(ids) {
      const seen = new Set();
      const result = [];
      ids.forEach(id => {
        const key = String(id);
        if (!seen.has(key)) {
          seen.add(key);
          result.push(id);
        }
      });
      return result;
    },
    _isSelected(id) {
      return this.selectedIds.some(item => String(item) === String(id));
    },
    initSearch() {
      this.showExtended = true;
      this.inputText = '';
      this.searchFunction('').then(data => {
        this.selectableItems = data['data'];
      });
    },
    onFocusOut() {
      this.showExtended = false;
      this.inputText = '';
    },
    onSearch() {
      clearTimeout(this.keyTimer);
      this.keyTimer = setTimeout(this._search, this.keyPressTimeoutMiliseconds);
    },
    _search() {
      this.searchFunction(this.inputText).then(data => {
        this.selectableItems = data['data'];
      });
    },
    highlightSearchedText(text) {
      return highlightText(text, this.inputText, '<span class="highlight">', '</span>');
    },
    selectItem(id, data) {
      if (this.disabled || this._isSelected(id)) {
        return;
      }
      this.selectedIds = [...this.selectedIds, id];
      this.$set(this.selectedData, id, data);
      this._emit();
    },
    removeItem(id) {
      if (this.disabled) {
        return;
      }
      this.selectedIds = this.selectedIds.filter(item => item !== id);
      this.$delete(this.selectedData, id);
      this._emit();
    },
    _initSorting() {
      if (!this.disabled && $('.sortable_' + this.name).length > 0) {
        $('.sortable_' + this.name).sortable({
          stop: this._sorted,
        });
        this.sortingEnabled = true;
      }
    },
    _sorted() {
      const order = [];
      $('.sorted_' + this.name).each((el, x) => {
        order.push($(x).attr('rowvalue'));
      });
      this.selectedIds = order
          .map(idStr => this.selectedIds.find(id => String(id) === idStr))
          .filter(id => id !== undefined);
      this._emit();
    },
    _emit() {
      this.$emit('input', this.selectedIds);
    },
  },
  watch: {
    value() {
      this.selectedIds = this._dedupe(this.value || []);
    },
    defaultData() {
      this.selectedData = this.defaultData ? { ...this.selectedData, ...this.defaultData } : this.selectedData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/SortableSearchSelect.vue